export const ADD_ORDER_CARD_LISTEN = "orders/ADD_ORDER_CARD_LISTEN"
export const GET_ORDER_CARDS_LISTEN = "order/GET_ORDER_CARDS_LISTEN"
export const ADD_ITEM_TO_CART = "order/ADD_ITEM_TO_CART"
export const REMOVE_ITEM_FROM_CART_LISTEN = "order/REMOVE_ITEM_FROM_CART_LISTEN"